import type {
  BindAgentInput,
  ChannelListItem,
  CreateChannelInput,
  CreateWhatsAppSessionInput,
  WhatsAppSessionItem,
} from '@qualibot/shared';
import { api } from './api-client';

export async function listChannels(): Promise<ChannelListItem[]> {
  const { data } = await api.get<{ items: ChannelListItem[] }>('/api/channels');
  return data.items;
}

export async function createChannel(input: CreateChannelInput): Promise<ChannelListItem> {
  const { data } = await api.post<ChannelListItem>('/api/channels', input);
  return data;
}

export async function bindChannelAgent(
  channelId: string,
  input: BindAgentInput,
): Promise<ChannelListItem> {
  const { data } = await api.post<ChannelListItem>(
    `/api/channels/${channelId}/bind-agent`,
    input,
  );
  return data;
}

export async function unbindChannelAgent(
  channelId: string,
  agentId: string,
): Promise<ChannelListItem> {
  const { data } = await api.delete<ChannelListItem>(
    `/api/channels/${channelId}/bind-agent/${agentId}`,
  );
  return data;
}

// --- WhatsApp sessions ---

export async function listWhatsAppSessions(): Promise<WhatsAppSessionItem[]> {
  const { data } = await api.get<{ items: WhatsAppSessionItem[] }>('/api/whatsapp/sessions');
  return data.items;
}

export async function fetchWhatsAppSession(id: string): Promise<WhatsAppSessionItem> {
  const { data } = await api.get<WhatsAppSessionItem>(`/api/whatsapp/sessions/${id}`);
  return data;
}

export async function createWhatsAppSession(
  input: CreateWhatsAppSessionInput,
): Promise<WhatsAppSessionItem> {
  const { data } = await api.post<WhatsAppSessionItem>('/api/whatsapp/sessions', input);
  return data;
}

export async function connectWhatsAppSession(id: string): Promise<WhatsAppSessionItem> {
  const { data } = await api.post<WhatsAppSessionItem>(`/api/whatsapp/sessions/${id}/connect`);
  return data;
}

export async function disconnectWhatsAppSession(id: string): Promise<WhatsAppSessionItem> {
  const { data } = await api.post<WhatsAppSessionItem>(`/api/whatsapp/sessions/${id}/disconnect`);
  return data;
}

export async function deleteWhatsAppSession(id: string): Promise<void> {
  await api.delete(`/api/whatsapp/sessions/${id}`);
}
